// extracted by mini-css-extract-plugin
export default {"comment":"CommentResultCard-module__comment--_JqIg","context":"CommentResultCard-module__context--kZTi6","animatedBackground":"CommentResultCard-module__animatedBackground--fwTV4"};